<template>
  <div>
    <div v-if="campaign_store.loading" class="space-y-2">
      <div class="h-8 w-48 animate-pulse rounded bg-gray-200"></div>
      <div class="h-6 w-32 animate-pulse rounded bg-gray-200"></div>
    </div>
    <div v-else>
      <div class="breadcrumbs mb-2 text-base font-bold">
        <ul>
          <li class="text-primary">
            <RouterLink :to="{ name: 'CampaignList' }"> Chiến dịch </RouterLink>
          </li>
          <li>
            {{ campaign_store.campaign_detail?.name }}
            <button
              class="ml-2 cursor-pointer"
              @click="copyCampaignId"
              title="Sao chép ID"
            >
              <span class="text-base-content/80 ms-4 font-normal">
                {{ campaign_store.campaign_detail?.id }}
                <i class="fa-regular fa-copy"></i>
              </span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="tabs tabs-border bg-base-100">
    <RouterLink
      v-for="tab in campaign_store.tabs"
      :key="tab.route_name"
      :to="{ name: tab.route_name, params: { campaign_id: campaign_store.id } }"
      :class="tw_merge('tab tab-lifted gap-1', is_active(tab.route_name))"
    >
      <i :class="tab.ico + ' opacity-90'"></i>
      {{ tab.value }}
    </RouterLink>
  </div>

  <div>
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { use_campaign_detail } from "@/components/Campaign/useCampaignDetail";
import { copyTextToClipboard } from "@/types/util";
import { twMerge as tw_merge } from "tailwind-merge";
import { useRoute } from "vue-router";

const route = useRoute();
const campaign_store = use_campaign_detail();

const copyCampaignId = () => {
  if (campaign_store.campaign_detail?.id) {
    copyTextToClipboard(campaign_store.campaign_detail.id);
  }
};

const is_active = (name: string) => {
  return route.name === name ? "tab-active" : "";
};
</script>
